import { AlertCircle, Home } from 'lucide-react';
import { Button } from '@client/components/ui/button';

interface MissingFormErrorProps {
  policyType?: string;
  stateOfResidence?: string;
  onGoHome?: () => void;
}

export function MissingFormError({
  policyType,
  stateOfResidence,
  onGoHome,
}: MissingFormErrorProps) {
  return (
    <div className="bg-primary-50 flex min-h-screen items-center justify-center">
      <div className="mx-auto max-w-md text-center">
        <div className="mb-4 flex justify-center">
          <AlertCircle className="h-12 w-12 text-amber-500" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-gray-900">Form Not Available</h2>
        <p className="mb-4 text-gray-700">
          An application form is not available for this policy and state. Please contact support for
          assistance.
        </p>
        <div className="mb-6 rounded-md bg-amber-50 p-4 text-left">
          {policyType && (
            <p className="text-sm text-amber-700">
              Policy Type: <span className="font-medium">{policyType}</span>
            </p>
          )}
          {stateOfResidence && (
            <p className="text-sm text-amber-700">
              State: <span className="font-medium">{stateOfResidence}</span>
            </p>
          )}
        </div>
        <div className="flex justify-center">
          {onGoHome && (
            <Button
              onClick={onGoHome}
              className="flex items-center gap-2"
            >
              <Home className="h-4 w-4" />
              Go to Dashboard
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
